import { useState } from "react";
import { Box, Typography, IconButton } from "@mui/material";
import StatusBadge from "../../../v2/MUI_custom_component/Badge/StatusBadge";
import { CustomButton } from "../../../v2/MUI_custom_component";
import dayjs from 'dayjs';
import IllustrationWrapper from "../../Illustrration/IllustrationWrapper";
import NoDataFoundSvg from "../../Illustrration/components/NoDataFoundSvg";
import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import IconReusable from "../../../components/IconReusable";

const AttachedDPList = ({ attachedDPData, loading }) => {
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const totalItems = attachedDPData.length;
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = Math.min(startIndex + itemsPerPage, totalItems);
    const currentItems = attachedDPData.slice(startIndex, endIndex);
    
    const handlePrevPage = () => {
        setCurrentPage(prev => Math.max(prev - 1, 1));
    };
    
    const handleNextPage = () => {
        setCurrentPage(prev => Math.min(prev + 1, totalPages));
    };

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            
            <Box sx={{ display: 'flex', 
                flexDirection: 'column',
                gap: 1,
                borderRadius: 2, 
                px: 2,
                backgroundColor: '#fff', 
                
            }}>
                
                {loading ? (
                    <Box sx={{ textAlign: 'center', p: 3 }}>
                        <Typography variant="body2" sx={{ color: '#666' }}>
                            Loading...
                        </Typography>
                    </Box>
                ) : attachedDPData && attachedDPData.length > 0 ? (
                    <>
                        {totalItems > 0 && (
                            <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 1, py: 1, borderBottom: '1px solid #D9D9D9', }}>
                                <Typography variant="p3">
                                    {startIndex + 1}-{endIndex} of {totalItems}
                                </Typography>
                                <IconButton 
                                    onClick={handlePrevPage} 
                                    disabled={currentPage === 1}
                                    size="24px"
                                >
                                    <IconReusable name='ArrowLeft' color="#995A00" size={12}/>
                                </IconButton>
                                <IconButton 
                                    onClick={handleNextPage} 
                                    disabled={currentPage === totalPages}
                                    size="24px"
                                    
                                >
                                    <IconReusable name='ArrowRight' color="#995A00" size={12}/>
                                </IconButton>
                            </Box>
                        )}
                        {currentItems.map((dp, index) => (
                            <Box key={dp.order_id || index} sx={{ 
                                borderBottom: index < currentItems.length - 1 ? '1px solid #D9D9D9' : 'none',
                                py: 2,
                                display: 'flex',
                                gap: { xs: 0.5, md: 0 },
                                flexDirection: { xs: 'column', md: 'row'}
                            }}>
                                
                                <Box sx={{ borderRight: { md: '1px solid #D9D9D9'}, display: 'flex', flexDirection: { xs: 'row', md: 'column'}, minWidth: {md: '180px'}, gap: 1 , justifyContent: {xs: 'space-between', md: 'flex-start'}, alignItems: { xs: 'center', md: 'flex-start'}, pr: { md: 2 }}}>
                                    <Typography variant="bodyL">
                                        {dayjs(dp.order_date).format('DD MMM YYYY')}
                                    </Typography>
                                    <Box sx={{ display: 'flex',flexDirection: {xs: 'row', md:'column'}, gap: 1, alignItems: { xs: 'center', md: 'flex-start' }}}>
                                        <Typography variant="labelM" sx={{ color: '#666'}}>
                                            Order ID
                                        </Typography>
                                        <Typography variant="p3" sx={{ fontWeight: 600}}>
                                            {dp.order_id}
                                        </Typography>
                                    </Box>
                                </Box>
                                <Box sx={{ display:{xs: 'flex', md:  'none'}, justifyContent: 'end' }}>
                                    <StatusBadge 
                                        label={dp.order_status}
                                        status={dp.order_status}
                                        size="small"
                                    />
                                </Box>
                                <Box sx={{ width: '100%', pl:{ md:  2 }, display: 'flex', flexDirection: 'column', gap: 1 }}> 
                                    <Box sx={{ display: 'flex', justifyContent : 'space-between', alignItems: 'flex-start', width: '100%' }}>
                                        {dp.ship_to_parties && dp.ship_to_parties.length > 0 && (
                                            <Box sx={{ display: 'flex', gap: {md: 1}, flexDirection: { xs: 'column', md:'row'}, }}>
                                                <Typography variant="labelM" sx={{ color: '#666' }}>
                                                    Ship to Party
                                                </Typography>
                                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                                                    {dp.ship_to_parties.map((party, pIndex) => (
                                                        <Box key={pIndex} sx={{ display: 'flex', alignItems: 'center' }}>
                                                            <Typography variant="bodyL">
                                                                {party.company_name}
                                                            </Typography>
                                                            {pIndex < dp.ship_to_parties.length - 1 && (
                                                                <Box sx={{ width: '100%', height: '1px', backgroundColor: '#D9D9D9', mx: 1, my: 0.5 }} />
                                                            )}
                                                        </Box>
                                                    ))}
                                                </Box>
                                            </Box>
                                        )}
                                        <Box sx={{ display:{xs: 'none', md:  'flex'}, alignItems: 'end' }}>
                                            <StatusBadge 
                                                label={dp.order_status}
                                                status={dp.order_status}
                                                size="small"
                                            />
                                        </Box>
                                    </Box>
                                    <Box sx={{ display: 'flex', justifyContent : 'space-between', alignItems: 'end', width: '100%' }}>
                                        <Box sx={{ display: 'flex', flexDirection: {xs: 'column', md: 'row' }, gap: {xs: 0, md: 4} }}>
                                            {dp.quantity_info && dp.quantity_info.length > 0 && dp.quantity_info.map((quantity, qIndex) => (
                                                <Box key={qIndex} sx={{ display: 'flex', flexDirection: { xs: 'row',md:'column'}, gap: {xs: 2, md: 1} }}>
                                                    <Typography variant="labelM" sx={{ color: '#666', minWidth: { xs: '80px', md: '100px' } }}>
                                                        {quantity.label}
                                                    </Typography>
                                                    <Typography variant="p3">
                                                        {quantity.value}
                                                    </Typography>
                                                </Box>
                                            ))}
                                        </Box>
                                        <Box sx={{ }}>
                                            <CustomButton
                                                label="View Details"
                                                variant="text"
                                                color="primary"
                                                sx={{ p: 0, textTransform: 'none', }}
                                                onClick={() => {
                                                    window.open(`/dispatch-plan/${dp.order_id}`, '_blank');
                                                }}
                                            />
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>
                        ))}
                        {totalItems > 0 && (
                            <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 1, py: 1, }}>
                                <Typography variant="p3">
                                    {startIndex + 1}-{endIndex} of {totalItems}
                                </Typography>
                                <IconButton 
                                    onClick={handlePrevPage} 
                                    disabled={currentPage === 1}
                                    size="24px"
                                >
                                    <IconReusable name='ArrowLeft' color="#995A00" size={12}/>
                                </IconButton>
                                <IconButton 
                                    onClick={handleNextPage} 
                                    disabled={currentPage === totalPages}
                                    size="24px"
                                    
                                >
                                    <IconReusable name='ArrowRight' color="#995A00" size={12}/>
                                </IconButton>
                            </Box>
                        )}
                    </>
                ) : null}
            </Box>

            {!loading && (!attachedDPData || attachedDPData.length === 0) && (
                <Box sx={{ 
                    textAlign: 'center',
                    p: 2
                }}>
                    <Box sx={{ mt: 4}}>
                        <IllustrationWrapper 
                            illustration={<NoDataFoundSvg />}
                            title="No Data"
                            subtitle="No attached dispatch plans found"
                        />
                    </Box>
                </Box>
            )}
        </Box>
    );
};

export default AttachedDPList;